import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SelectedCategory } from '../product-catalog.component';
import { AccueilDataService } from 'src-ironside/services/accueil-data.service';
import { ScreenMediator } from 'src-ironside/services/screen.mediator';
import { SessionStorageService } from 'src-ironside/services/session-storage.service';
import { flatCategories } from 'src-ironside/utils/categories';
import { Category } from 'src-ironside/repositories/category.repository';

@Component({
    selector: 'app-product-catalog-dialog',
    templateUrl: './product-catalog-dialog.component.html',
    styleUrls: ['./product-catalog-dialog.component.css'],
})
export class ProductCatalogDialogComponent implements OnInit {
    public get isVisible(): boolean {
        return true;
    }
    public set isVisible(val: boolean) {
        if (!val) {
            this.dialogRef.close();
        }
    }

    categories?: SelectedCategory[];

    constructor(
        private accueilDataService: AccueilDataService,
        private screenMediator: ScreenMediator,
        private dialogRef: MatDialogRef<ProductCatalogDialogComponent>,
        private sessionStorageService: SessionStorageService,
        @Inject(MAT_DIALOG_DATA) public data?: { categories: SelectedCategory[] }
    ) {
        this.categories = data?.categories;
    }

    ngOnInit(): void {}

    onChange(category: SelectedCategory, parentCategory?: SelectedCategory) {
        // this.changeStateAllSubCategories(category);
        // if (parentCategory && parentCategory.subCategory) {
        //     parentCategory.selected = parentCategory.subCategory.every(
        //         (childCat: SelectedCategory) => childCat.selected == true
        //     );
        // }
    }

    submit() {
        const selectedCatogoryIds: string[] = [];
        const categoriesFlat: SelectedCategory[] = flatCategories(this.categories);

        const categorySelected: any = categoriesFlat?.filter((el) => el.selected).flat();
        this.categories?.forEach((category: SelectedCategory) => {
            this.getSelectedSubCategories(selectedCatogoryIds, category);
        });

        const ids = categorySelected.map((el: any) => el.id);
        const idsCatalogChecked = this.getIdCatalog(categorySelected);

        this.dialogRef.close();
        this.accueilDataService.filterData = {
            categoryList: categorySelected,
        };

        /* Flag Modal Categories */
        this.sessionStorageService.setFilters({
            isCategoryModal: true,
            categoryList: ids,
            categories: idsCatalogChecked,
        });
        this.screenMediator.toRecherche();
    }

    getIdCatalog(category: Category[]) {
        return category.flatMap((el: any) => {
            const categoryId: string[] = [el?.id!];
            function findCategory(category: Category) {
                category.subcategoryList.forEach((i: any) => {
                    categoryId.push(i?.id!);
                    if (i?.subcategoryList?.length > 0) {
                        findCategory(i);
                    }
                });
            }
            findCategory(el);
            return categoryId;
        });
    }

    changeStateAllSubCategories(category: SelectedCategory) {
        if (category.subCategory) {
            category.subCategory.forEach((childCat: SelectedCategory) => {
                childCat.selected = category.selected;
                if (childCat.subCategory) {
                    this.changeStateAllSubCategories(childCat);
                }
            });
        }
    }

    getSelectedSubCategories(selectedCatogoryIds: string[], cat: SelectedCategory) {
        if (cat.selected && cat.codeCategory) {
            selectedCatogoryIds.push(cat?.id!);
        }
        if (cat.subCategory) {
            cat.subCategory.forEach((category: SelectedCategory) => {
                this.getSelectedSubCategories(selectedCatogoryIds, category);
            });
        }
    }
}
